'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { trackSeoLinkClick } = require('../../actions/pdpTrackingActions');

const SeoLink = ({ link }, context) => (
    <li className="seo-link colXs12 colMd4">
        <a href={link.url} onClick={() => context.executeAction(trackSeoLinkClick, { label: '' })}>
            {link.anchorText}
        </a>
    </li>
);

SeoLink.propTypes = {
    link: PropTypes.object.isRequired,
};

SeoLink.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

module.exports = SeoLink;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/SeoLinks/SeoLink.jsx